import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-detail-stand-client',
  templateUrl: './detail-stand-client.component.html',
  styleUrls: ['./detail-stand-client.component.css']
})
export class DetailStandClientComponent implements OnInit {

 
  routeSub:Subscription;
  idClient:number;
 
 
   constructor( private activatedRoute:ActivatedRoute ) { 
       this.routeSub = this.activatedRoute.params.subscribe(params => {
  
  
    this.idClient=params['idClient'];
        
     
   });
 }
  ngOnInit() {
  }

}
